import { gql, useQuery, useLazyQuery } from '@apollo/client';

// TODO: Split up admin, user, and 'condensed' queries

const ADMIN_MEMBER_EVENT_BY_ID_QUERY = gql`
  query memberEventByIdQuery($id: Int!) {
    memberEventById(id: $id) {
      id
      name
      descriptionRaw
      ticketDetailsRaw
      coverImageUrl
      headshotImageUrl
      sponsorLogoUrls
      imageUrls
      flyerImageUrl
      meetingUrl
      meta
      isVirtual
      isPartner
      venueId
      utcDate
      timezone
      isDateTbd
      deletedAt
      isPurchasable
      isMemberExclusive
      status
      venueByVenueId {
        id
        name
        cityName
        timezone
      }
      memberEventTalentsByMemberEventId {
        nodes {
          id
          talentByTalentId {
            id
            name
          }
          isModerator
        }
      }
      virtualEventUrlsByMemberEventId {
        nodes {
          id
          url
        }
      }
      ticketsSold
      maxCapacity
      ticketTypesByMemberEventId(filter: {
        deletedAt: {
          isNull: true
        }
      }) {
        nodes {
          id
          name
          description
          priceCents
          priceCredits
          quantity
          sold
        }
      }
    }
  }
`;

export const useLazyAdminMemberEvent = (onCompleted) => {
  const [
    getMemberEvent,
    {
      loading,
      error,
      data: rawData,
    },
  ] = useLazyQuery(ADMIN_MEMBER_EVENT_BY_ID_QUERY, { fetchPolicy: 'network-only', onCompleted });

  let data;
  if (!loading && rawData) {
    data = rawData.memberEventById;

    const primaryTalentList = [];
    const moderatorTalentList = [];

    // Make it a little easier to use this nested field
    data.memberEventTalentsByMemberEventId.nodes.forEach(({ isModerator, talentByTalentId }) => {
      if (isModerator) {
        moderatorTalentList.push(talentByTalentId);
      } else {
        primaryTalentList.push(talentByTalentId);
      }
    });

    data.primaryTalentList = primaryTalentList;
    data.moderatorTalentList = moderatorTalentList;

    // Make it a little easier to use this nested field
    data.ticketTypes = data.ticketTypesByMemberEventId.nodes.map((ticketType) => ticketType);
  }

  return {
    getMemberEvent,
    loading,
    data,
    error,
  };
};

const useAdminMemberEvent = (memberEventId, query) => {
  const {
    loading,
    error,
    data: rawData,
    refetch,
  } = useQuery(query || ADMIN_MEMBER_EVENT_BY_ID_QUERY, {
    variables: { id: +memberEventId },
    skip: !memberEventId,
    fetchPolicy: 'network-only',
  });

  let data;
  if (!loading && rawData) {
    data = rawData.memberEventById;
    const primaryTalentList = [];
    const moderatorTalentList = [];

    // Make it a little easier to use this nested field
    data.memberEventTalentsByMemberEventId.nodes.forEach(({ isModerator, talentByTalentId }) => {
      if (isModerator) {
        moderatorTalentList.push(talentByTalentId);
      } else {
        primaryTalentList.push(talentByTalentId);
      }
    });

    data.primaryTalentList = primaryTalentList;
    data.moderatorTalentList = moderatorTalentList;

    [data.virtualEventUrl] = data.virtualEventUrlsByMemberEventId.nodes;
  }
  return {
    refetch,
    loading,
    data,
    error,
  };
};

export default useAdminMemberEvent;
